import React, { useRef } from 'react';
import CustomHook from './CustomHook';
import myImage from '../images/gevorkAvatar.jpg';

function Home() {
  const scrollTab = useRef();
  CustomHook(scrollTab);

  const handleDownload = (event) => {
    event.preventDefault(); // Предотвращаем действие по умолчанию
    // Указываем путь к файлу в папке public
    const fileUrl = `${process.env.PUBLIC_URL}/CV-gevork.pdf`;

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'CV-gevork.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section ref={scrollTab} className="home">
      <div className="content">
        <div className="name">
          Hi, I'm <span>Gevork Sarkisyan</span>
        </div>
        <div className="des">
          {/* 30 */}I am a frontend junior developer and I am looking for a job in this position. I
          will be happy to complete tasks provided by the team leader. I am very hardworking and
          always ready for something new, and would like to be part of some company. I have 2 years
          of development experience, including on my own pet projects, but also in a team, actively
          using the Git version control system for convenient collaborative development. I always
          strive to learn something new and am not lazy. I developed applications on React, Next:
          landing pages, online stores, chats, social networks, etc., and in my free time I study,
          or rather watch video tutorials, layout websites, study new technologies and libraries.
        </div>

        <a
          onClick={handleDownload}
          href="!#"
          target="_blank"
          rel="noopener noreferrer"
          className="animation active ">
          {' '}
          Download CV
        </a>
      </div>
      <div className="avatar">
        <div className="card">
          <img src={myImage} alt="myImage" />
          <div className="info">
            <div>Frontend Developer</div>
            <div>Level</div>
            <div>2 year experience </div>
            <div>Junior</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
